// extracted by mini-css-extract-plugin
export default {"list":"ContactList_list__csErn","item":"ContactList_item__EZYHO"};